/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TransPb } from "../body/trans";
import { Frame } from "./frame";
import { Geometry } from "./geometry";

export const protobufPackage = "structure";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface StructureObject {
  frame: Frame | undefined;
  frameTObject: TransPb | undefined;
  geometry: Geometry | undefined;
}

function createBaseStructureObject(): StructureObject {
  return { frame: undefined, frameTObject: undefined, geometry: undefined };
}

export const StructureObject = {
  encode(message: StructureObject, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.frame !== undefined) {
      Frame.encode(message.frame, writer.uint32(10).fork()).ldelim();
    }
    if (message.frameTObject !== undefined) {
      TransPb.encode(message.frameTObject, writer.uint32(18).fork()).ldelim();
    }
    if (message.geometry !== undefined) {
      Geometry.encode(message.geometry, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StructureObject {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStructureObject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.frame = Frame.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.frameTObject = TransPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.geometry = Geometry.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StructureObject {
    return {
      frame: isSet(object.frame) ? Frame.fromJSON(object.frame) : undefined,
      frameTObject: isSet(object.frameTObject) ? TransPb.fromJSON(object.frameTObject) : undefined,
      geometry: isSet(object.geometry) ? Geometry.fromJSON(object.geometry) : undefined,
    };
  },

  toJSON(message: StructureObject): unknown {
    const obj: any = {};
    if (message.frame !== undefined) {
      obj.frame = Frame.toJSON(message.frame);
    }
    if (message.frameTObject !== undefined) {
      obj.frameTObject = TransPb.toJSON(message.frameTObject);
    }
    if (message.geometry !== undefined) {
      obj.geometry = Geometry.toJSON(message.geometry);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StructureObject>, I>>(base?: I): StructureObject {
    return StructureObject.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StructureObject>, I>>(object: I): StructureObject {
    const message = createBaseStructureObject();
    message.frame = (object.frame !== undefined && object.frame !== null) ? Frame.fromPartial(object.frame) : undefined;
    message.frameTObject = (object.frameTObject !== undefined && object.frameTObject !== null)
      ? TransPb.fromPartial(object.frameTObject)
      : undefined;
    message.geometry = (object.geometry !== undefined && object.geometry !== null)
      ? Geometry.fromPartial(object.geometry)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
